import SideNav from '@components/common/sidebar';
import { images } from '@constants/images';
import useScreenSize from '@hooks/useScreenSize';
import { RootState } from '@utils/types';
import { Drawer } from 'flowbite-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IoIosArrowForward } from 'react-icons/io';
import { RiCloseFill } from 'react-icons/ri';
import { RxHamburgerMenu } from 'react-icons/rx';
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import ProfilePopper from './profile-popover';
import TierBadge from './tier-badge';
import UserDetail from './user-detail';

const Header = () => {
  const { t: translate } = useTranslation();
  const navigate = useNavigate();
  const { id = '', tier } = useSelector((state: RootState) => state.user);

  const [openDrawer, setOpenDrawer] = useState(false);

  const handleDrawerToggle = (val: boolean = false) => setOpenDrawer(val);

  const navigateToProfilePage = () => {
    navigate('/profile');
    handleDrawerToggle();
  };

  const { isMobile } = useScreenSize();

  return (
    <>
      <div className="sticky top-0 z-10 flex h-16 items-center border-b border-slate-200 bg-white px-3">
        <div className="mr-auto flex">
          {isMobile && id !== '' && (
            <button
              className="mr-4 border-0 bg-white p-0 font-bold lg:hidden"
              onClick={() => handleDrawerToggle(true)}
            >
              <RxHamburgerMenu size={25} />
            </button>
          )}
          <img src={images.logo} alt="L&T Finance" className="w-32 lg:ml-2" />
          {id !== '' && (
            <>
              <img
                src={images.vppLogo}
                alt="VPP Logo"
                className="ml-2 h-16 py-1 lg:ml-20"
              />
              <span className="ml-4 flex items-center lg:text-lg">
                <span className="hidden lg:block">
                  {translate('layoutHeader.vppLogoHeader')}
                </span>
                <span className="block lg:hidden">
                  {translate('layoutHeader.vppLogoHeaderMobile')}
                </span>
              </span>
            </>
          )}
        </div>
        {id !== '' ? (
          <>
            {tier !== 'non-vpp' && <TierBadge />}
            {isMobile === false && (
              <span className="hidden lg:flex">
                <UserDetail />
                <ProfilePopper />
              </span>
            )}
          </>
        ) : (
          <Link
            to="/login"
            className="rounded-lg bg-black px-3 py-2 text-xs text-white hover:bg-slate-800 lg:px-4 lg:text-base"
          >
            {translate('landingPage.loginBtn')}
          </Link>
        )}
      </div>

      {isMobile && id !== '' && (
        <Drawer
          open={openDrawer}
          onClose={handleDrawerToggle}
          theme={{
            root: {
              base: 'fixed z-40 overflow-y-auto bg-white transition-transform dark:bg-gray-800 lg:hidden',
            },
          }}
        >
          <Drawer.Items>
            <div className="flex bg-lt-yellow py-6 pl-4 pr-6">
              <UserDetail />
              <IoIosArrowForward
                className="ml-2 mt-1.5 h-4 w-4"
                onClick={navigateToProfilePage}
              />
              <button
                className="ml-auto h-fit border-0 bg-transparent p-0"
                onClick={() => handleDrawerToggle()}
              >
                <RiCloseFill className="mb-auto h-6 w-6" />
              </button>
            </div>
            <div className="h-[calc(100vh-88px)]">
              <SideNav closeDrawer={() => handleDrawerToggle()} />
            </div>
          </Drawer.Items>
        </Drawer>
      )}
    </>
  );
};

export default Header;
